module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Novels by ")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("NDREW")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v(" G")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("REY")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Accompanied by a Waltz")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Dutch Treat")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("A Heart Without Borders")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("In Search of a Story")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Inside Out")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Stranded • Taken")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Three Fates (anthology)")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Work Me Out (anthology)")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("RT")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Legal Artistry • Artistic Appeal • Artistic Pursuits • Legal Tender")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OTTLED")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" U")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("TORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Bottled Up • Uncorked • The Best Revenge • An Unexpected Vintage")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("HE")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" B")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ULLRIDERS")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("A Daring Ride • A Wild Ride")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("HILDREN")]), _c('span', {
    staticClass: "t7"
  }), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OF")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" B")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ACCHUS")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("TORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Children of Bacchus • Thursday’s Child • Child of Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OOD")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" F")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("IGHT")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("The Good Fight • The Fight Within • The Fight for Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OVE")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" M")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("EANS")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("… S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Love Means… No Shame • Love Means… Courage • Love Means… No Boundaries")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Love Means… Freedom • Love Means … No Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Love Means… Family • Love Means… Renewal • Love Means… No Limits")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ENSES")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("TORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Love Comes Silently • Love Comes in Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("EVEN")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" D")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("AYS")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("TORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Seven Days • Unconditional Love")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("TORIES")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" F")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ROM")]), _c('span', {
    staticClass: "t7"
  }), _c('span', {
    staticClass: "t10"
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" R")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ANGE")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("A Shared Range • A Troubled Range • An Unsettled Range")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("A Foreign Range • An Isolated Range• A Volatile Range")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ASTE")]), _c('span', {
    staticClass: "t7"
  }), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OF")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" L")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OVE")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("TORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("A Taste of Love • A Serving of Love • A Helping of Love • A Slice of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Published by ")]), _c('span', {
    staticClass: "t12"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("REAMSPINNER")]), _c('span', {
    staticClass: "t12"
  }, [_vm._v(" P")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("http://www.dreamspinnerpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Novellas by ")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("NDREW")]), _c('span', {
    staticClass: "t8"
  }, [_vm._v(" G")]), _c('span', {
    staticClass: "t9"
  }, [_vm._v("REY")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("A Present in Swaddling Clothes")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Biochemistry • Organic Chemistry")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Shared Revelations")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Snowbound in Nowhere")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Whipped Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("IRE")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Redemption by Fire • Strengthened by Fire • Burnished by Fire • Heat Under Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("HILDREN")]), _c('span', {
    staticClass: "t7"
  }), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OF")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" B")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ACCHUS")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("TORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Spring Reassurance • Winter Love")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("OVE")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" M")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("EANS")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v("… S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Love Means… Healing • Love Means… Renewal")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ORK")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" O")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("UT")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(" S")]), _c('span', {
    staticClass: "t10"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Spot Me • Pump Me Up • Core Training • Crunch Time")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Positive Resistance • Personal Training • Cardio Conditioning")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("Published by ")]), _c('span', {
    staticClass: "t12"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("REAMSPINNER")]), _c('span', {
    staticClass: "t12"
  }, [_vm._v(" P")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("http://www.dreamspinnerpress.com")]), _c('span', {
    staticClass: "t14"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae2c032","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0